class Loader
    constructor: (el) ->
        @.$el = el

        @.shown = @.$el.classList.contains 'loader--shown'

        @.$el.classList.add 'loader--bound'
        @.InitEvents()
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'loader-show', (e) ->
            self.ShowLoaderState true
            return
        @.$el.addEventListener 'loader-hide', (e) ->
            self.ShowLoaderState false
            return
        return
    
    ShowLoaderState: (shown) ->
        if shown
            @.$el.classList.add 'loader--shown'
            @.shown = true
        else
            @.$el.classList.remove 'loader--shown'
            @.shown = false
        return

BindLoaders = ->
    document.querySelectorAll '.loader:not(.loader--bound)'
        .forEach (el) ->
            new Loader el
            return
    return

window.addEventListener 'bind-components', BindLoaders

class LoaderCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.bindLater = options?.bindLater ? false
        @.color = options?.color ? false
        @.shown = options?.shown ? false
        @.tag = options?.tag ? 'div'
        @.text = options?.text ? false

        @.CreateElement()
        if !@.bindLater
            new Loader @.$el
        return @.$el
    
    CreateElement: ->
        @.$el = document.createElement @.tag
        @.$el.classList.add 'loader'
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        if @.color
            @.$el.classList.add "loader--#{ @.color }"
        if @.shown
            @.$el.classList.add 'loader--shown'
        @.$el.innerHTML = "
            <span class='loader__spinner'></span>
            #{ if @.loaderText then "<span class='loader__text'>#{ @.loaderText }</span>" else "" }
        "
        return

window.CreateLoader = (options) ->
    return new LoaderCreate options